<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h3>Add New FAQ</h3>
      <AddElement category_id="6"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewFAQ",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'FAQs',
          to: '/faqs/all'
        }, {
          text: 'Add FAQ',
          href: '#'
        }
      ],
    };
  },
};
</script>